export type TemplateType = string[][];

export const COMMUNITY_MEMBER_STAKEHOLDER_TEMPLATE: TemplateType = [
  [
    'Type',
    'Name',
    'Surname',
    'National ID',
    'Gender',
    'Date Of Birth',
    'Population Group',
    'Home Language',
    'Contact Number',
    'Email Address',
    'Primary Institution',
    'Primary Start Date',
    'Primary End Date',
    'Additional Institutions',
    'Additional  Start Date',
    'Additional  End Date',
    'Community Type',
    'Country',
    'Province',
    'District',
    'Local Municipality',
    'Role',
    'Date Exited',
    'Reason for Exit',
    'Case ID',
    'Household ID',
  ],
  [
    'Community Members',
    'Oswald',
    'Ward',
    '19283746',
    'Male',
    '1990-03-11',
    'Black African',
    'Tsonga',
    '088 804 0232',
    'Idell39@yahoo.com',
    '443907266',
    '2020-01-01',
    '2021-12-31',
    '443611257/442204243',
    '2020-01-01/2020-01-01',
    '2021-12-31/2021-12-31',
    'School Community',
    'South Africa',
    'Free State',
    'Motheo',
    'Abaqulusi Local Municipality',
    'Parent/Caregiver',
    '2019-10-30',
    'Migrated',
    '1234567890',
    '1234567890',
  ],
];

export const SOCIAL_SERVICES_PROFESSIONAL_STAKEHOLDER_TEMPLATE: TemplateType = [
  [
    'Type',
    'Name',
    'Surname',
    'National ID',
    'Gender',
    'Date Of Birth',
    'Population Group',
    'Home Language',
    'Contact Number',
    'Email Address',
    'Primary Institution',
    'Primary Start Date',
    'Primary End Date',
    'Additional Institutions',
    'Additional  Start Date',
    'Additional  End Date',
    'Persal Number',
    'Personnel Position',
    'Personnel Position Other',
    'Designation',
    'Date Exited',
    'Reason for Exit',
  ],
  [
    'Social Services Professionals',
    'Oswald',
    'Ward',
    '19283746',
    'Male',
    '1990-03-11',
    'Black African',
    'Tsonga',
    '088 804 0232',
    'Idell39@yahoo.com',
    '443907266',
    '2020-01-01',
    '2021-12-31',
    '443611257/442204243',
    '2020-01-01/2020-01-01',
    '2021-12-31/2021-12-31',
    '2498c8a0-a956-410e-8fe3-92124f954634',
    'Other',
    'PP Other',
    'Director',
    '2019-10-30',
    'Transferred to Another School',
  ],
];

export const DISTRICT_OFFICIALS_STAKEHOLDER_TEMPLATE: TemplateType = [
  [
    'Type',
    'Name',
    'Surname',
    'National ID',
    'Gender',
    'Date Of Birth',
    'Population Group',
    'Home Language',
    'Contact Number',
    'Email Address',
    'Primary Institution',
    'Primary Start Date',
    'Primary End Date',
    'Additional Institutions',
    'Additional  Start Date',
    'Additional  End Date',
    'Persal Number',
    'Personnel Position',
    'Personnel Position Other',
    'Designation',
    'Phase',
    'Subject Code',
    'Date Exited',
    'Reason for Exit',
  ],
  [
    'District Officials',
    'Oswald',
    'Ward',
    '19283746',
    'Male',
    '1990-03-11',
    'Black African',
    'Tsonga',
    '088 804 0232',
    'Idell39@yahoo.com',
    '443907266',
    '2020-01-01',
    '2021-12-31',
    '443611257/442204243',
    '2020-01-01/2020-01-01',
    '2021-12-31/2021-12-31',
    '2498c8a0-a956-410e-8fe3-92124f954634',
    'Other',
    'PP Other',
    'Director',
    'Foundation',
    '13312872/13302842/13302852',
    '2019-10-30',
    'Transferred to Another School',
  ],
];

export const LEARNERS_STAKEHOLDER_TEMPLATE: TemplateType = [
  [
    'institutionId',
    'institution',
    'district',
    'localMunicipality',
    'wardLabel',
    'emisNumber',
    'trackingCode',
    'Type',
    'FirstName',
    'Surname',
    'Gender',
    'Date of Birth',
    'Citizenship',
    'Identification Type',
    'National ID',
    'Passport Number',
    'Birth Certificate / ID',
    'Applied for Birth Certificate / ID',
    'Study Permit',
    'Study Permit Number',
    'Reason for Lack of Birth Certificate / ID',
    'Population Group',
    'Home Language',
    'Contact Number',
    'Email Address',
    'Road to Health Card',
    'Reason for Lack of Road to Health Card',
    'Disability',
    'Disability Type(s)',
    'Special Needs',
    'Orphaned / Vulnerable Child',
    'Receiving Social Grant',
    'Grant Type',
    'Tracking ID / Admission Number',
    'Registration Date',
    'Date Exited',
    'Caregiver Type1',
    'Caregiver Relationship1',
    'Caregiver Name1',
    'Caregiver Surname1',
    'Caregiver Gender1',
    'Caregiver Citizenship1',
    'Caregiver Identification Type1',
    'Caregiver Passport Number1',
    'Caregiver National ID1',
    'Caregiver Marital Status1',
    'Caregiver Country Code1',
    'Caregiver Contact Number1',
    'Caregiver Email Address1',
    'Caregiver Physical Address1',
    'Employment Status1',
    'Caregiver Occupation1',
    'Caregiver Occupation: Other1',
    'Caregiver Employer1',
    'Monthly Income1',
    'Monthly Income Range1',
    'Income Source Document1',
    'Child resides with this caregiver1',
    'Account Payer1',
    'Caregiver Type2',
    'Caregiver Relationship2',
    'Caregiver Name2',
    'Caregiver Surname2',
    'Caregiver Gender2',
    'Caregiver Citizenship2',
    'Caregiver Identification Type2',
    'Caregiver Passport Number2',
    'Caregiver National ID2',
    'Caregiver Marital Status2',
    'Caregiver Country Code2',
    'Caregiver Contact Number2',
    'Caregiver Email Address2',
    'Caregiver Physical Address2',
    'Employment Status2',
    'Caregiver Occupation2',
    'Caregiver Occupation: Other2',
    'Caregiver Employer2',
    'Monthly Income2',
    'Monthly Income Range2',
    'Income Source Document2',
    'Child resides with this caregiver2',
    'Account Payer2',
  ],
  [
    '',
    '1000 Hills Community Helpers',
    '',
    '',
    '',
    '',
    '',
    'Learners',
    'Moses',
    'Ncobo',
    'Male',
    '2020/05/20',
    'South African',
    'RSA ID',
    '2002078027186',
    '19284d3948',
    'TRUE',
    'FALSE',
    'Yes',
    '2039485',
    "I don't know how to apply",
    'Black African',
    'English',
    '0833736242',
    'Moses@gmail.com',
    'No',
    'Lost',
    'Yes',
    'Aphasia,Anxiety Disorder',
    'None',
    '',
    'Yes',
    'Child Support',
    '503da3a6-1f23-11ee-be56-0242ac120002',
    '2022/08/18',
    '2023/08/18',
    'Parent',
    'Birth Parent',
    'Milton',
    'Ncobo',
    'Male',
    'South African',
    'RSA ID',
    '726328h',
    '9302078027186',
    'Single',
    '',
    '0833736242',
    'milton@gmail.com',
    '12 Arcacia St, Arcasia, Johannesburg, 2007',
    'Employed',
    'Accountant',
    'Education',
    '',
    '5000',
    'R3501 upwards',
    'Proof of Income',
    'Yes',
    'Yes',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
  ],
];

export const PROVINCIAL_OFFICIALS_STAKEHOLDER_TEMPLATE: TemplateType = [
  [
    'Type',
    'Name',
    'Surname',
    'National ID',
    'Gender',
    'Date Of Birth',
    'Population Group',
    'Home Language',
    'Contact Number',
    'Email Address',
    'Primary Institution',
    'Primary Start Date',
    'Primary End Date',
    'Additional Institutions',
    'Additional  Start Date',
    'Additional  End Date',
    'Persal Number',
    'Country',
    'Province',
    'Region',
    'Branch',
    'Personnel Position',
    'Personnel Position Other',
    'Role',
    'Other Role',
    'Designation',
    'Date Exited',
    'Reason for Exit',
  ],
  [
    'Provincial Officials',
    'Oswald',
    'Ward',
    '19283746',
    'Male',
    '11/03/1990',
    'Black African',
    'Tsonga',
    '088 804 0232',
    'Idell39@yahoo.com',
    '443907266',
    '2020-01-01',
    '2021-12-31',
    '443611257/442204243',
    '2020-01-01/2020-01-01',
    '2021-12-31/2021-12-31',
    '2498c8a0-a956-410e-8fe3-92124f954634',
    'South Africa',
    'Free State',
    'Johannesburg',
    'My Branch',
    'Other',
    'PP Other',
    '',
    '',
    'My Designation',
    '30/10/2019',
    'Transferred to Another School',
  ],
];

export const NATIONAL_OFFICIALS_STAKEHOLDER_TEMPLATE: TemplateType = [
  [
    'Type',
    'Name',
    'Surname',
    'National ID',
    'Gender',
    'Date Of Birth',
    'Population Group',
    'Home Language',
    'Contact Number',
    'Email Address',
    'Primary Institution',
    'Primary Start Date',
    'Primary End Date',
    'Additional Institutions',
    'Additional  Start Date',
    'Additional  End Date',
    'Persal Number',
    'Country',
    'Branch',
    'Personnel Position',
    'Personnel Position Other',
    'Designation',
    'Date Exited',
    'Reason for Exit',
  ],
  [
    'National Officials',
    'Oswald',
    'Ward',
    '19283746',
    'Male',
    '1990-03-11',
    'Black African',
    'Tsonga',
    '088 804 0232',
    'Idell39@yahoo.com',
    'BARNARD MOLOKOANE S/S',
    '2020-01-01',
    '2021-12-31',
    '443611257/442204243',
    '2020-01-01/2020-01-01',
    '2021-12-31/2021-12-31',
    '2498c8a0-a956-410e-8fe3-92124f954634',
    'South Africa',
    'My Branch',
    'Other',
    'PP Other',
    'My Designation',
    '2019-10-30',
    'Transferred to Another School',
  ],
];

export const SCHOOL_OFFICIALS_STAKEHOLDER_TEMPLATE: TemplateType = [
  [
    'Type',
    'Name',
    'Surname',
    'National ID',
    'Gender',
    'Date Of Birth',
    'Population Group',
    'Home Language',
    'Contact Number',
    'Email Address',
    'Primary Institution',
    'Primary Start Date',
    'Primary End Date',
    'Additional Institutions',
    'Additional  Start Date',
    'Additional  End Date',
    'Persal Number',
    'Personnel Position',
    'Personnel Position Other',
    'Post Level',
    'Date Started',
    'Nature of Employment',
    'Remuneration Source',
    'Educator Level',
    'Years of Experience',
    'Lead Educator',
    'ICT Skill',
    'Highest Qualification',
    'Multigrade',
    'Grade',
    'Subject Code',
    'Date Exited',
    'Reason for Exit',
  ],
  [
    'School Officials',
    'Oswald',
    'Ward',
    '',
    'Male',
    '1990-03-11',
    'Black African',
    'Tsonga',
    '088 804 0232',
    'Idell39@yahoo.com',
    '443907266',
    '2020-01-01',
    '2021-12-31',
    '443611257/442204243',
    '2020-01-01/2020-01-01',
    '2021-12-31/2021-12-31',
    '2498c8a0-a956-410e-8fe3-92124f954634',
    'Educator',
    'PP Other',
    '9',
    '2018-01-13',
    'Permanent',
    'State',
    'Grade R',
    '4',
    'true',
    '0',
    'Professional Teaching Qualification',
    'false',
    '1/2',
    '13312872/13302842/13302852',
    '2019-10-30',
    'Transferred to Another School',
  ],
];

export const SCHOOL_ATTENDANCE_TEMPLATE = [
  [
    'year',
    'term',
    'emisNumber',
    'grade',
    'numberEnrolled',
    'possibleAttendance',
    'absentDays',
    'actualAttendance',
    'attendanceRate',
    'absenteeismRate',
    'dateAccessed',
    'dateCreated',
    'dataSource',
    'dateSchoolSubmitted',
  ],
  [
    '2008',
    'Term 1',
    200300002,
    3,
    123,
    123,
    123,
    123,
    123.12,
    123.12,
    '29/03/2020',
    '27/02/2020',
    'SA-SAMS',
    '21/02/2020',
  ],
];

export const SCHOOL_PROMOTION_TEMPLATE = [
  [
    'year',
    'term',
    'emisNumber',
    'grade',
    'promotionStatus',
    'numberEnrolled',
    'numberWrote',
    'numberPassed',
    'percentagePassed',
    'gradeAverage',
    'dateAccessed',
    'dateCreated',
    'dataSource',
    'dateSchoolSubmitted',
  ],
  ['2011', 'Term 1', 200300002, 3, 'Not Promoted', 3, 4, 5, 5, 7, '29/03/2020', '27/02/2020', 'SA-SAMS', '21/02/2020'],
];

export const EDUCATOR_ATTENDANCE_TEMPLATE = [
  [
    'year',
    'term',
    'emisNumber',
    'educatorName',
    'attendanceRate',
    'daysAbsent',
    'dateAccessed',
    'dateCreated',
    'dataSource',
    'dateSchoolSubmitted',
  ],
  ['2008', 'Term 1', 200300002, 'My Educator', '9', 3, '29/03/2020', '27/02/2020', 'SA-SAMS', '21/02/2020'],
];

export const SCHOOL_ENROLMENT_TEMPLATE = [
  [
    'year',
    'term',
    'emisNumber',
    'grade',
    'promotionStatus',
    'numberEnrolled',
    'numberWithoutID',
    'dateAccessed',
    'dateCreated',
    'dataSource',
    'dateSchoolSubmitted',
  ],
  ['2011', 'Term 1', 200300002, 3, 'Not Promoted', 3, 5, '29/03/2020', '27/02/2020', 'SA-SAMS', '21/02/2020'],
];

export const INSTITUTION_TEMPLATE = [['emisNumber'], [200500005]];

export const FUNDER_TEMPLATE = [
  [
    'contactPerson',
    'contactPersonContactNumber',
    'contactPersonEmail',
    'description',
    'leaderContactNumber',
    'leaderEmail',
    'leaderTitle',
    'name',
    'organisationLeader',
    'physicalAddress',
    'website',
  ],
  [
    'John Doe',
    '0897898765',
    'email@mine.com',
    'My description',
    '0897898765',
    'email@mine.com',
    'Mr',
    'John Doe',
    'James Leader',
    '9 5th Avenue, Johannesburg',
    'www.example.com',
  ],
];

export const TEAM_MEMBER_TEMPLATE = [
  ['firstName', 'lastName', 'email', 'role', 'gender', 'designation', 'idNum', 'status', 'contactNumber'],
  ['John', 'Doe', 'email@mine.com', 'Funder Admin', 'Male', 'Designation', '01231212', 'ACTIVE', '0918881111'],
];

export const SERVICE_PROVIDER_TEMPLATE = [
  [
    'firstName',
    'lastName',
    'email',
    'gender',
    'idNum',
    'contactNumber',
    'designation',
    'role',
    'status',
    'serviceProviderName',
    'embedCode',
    'invite',
  ],
  [
    'John',
    'Doe',
    'email@mine.com',
    'Male',
    '01231212',
    'e.g 0918881111',
    'Designation',
    'Admin',
    'ACTIVE',
    'READ',
    'https://datastudio.google.com/embed/reporting/13u0MrSyD_uI6moFSbJIuEATbF7xtFGkp/page/oU8b',
    'true',
  ],
];

export const NSC_PROGRESSION_TEMPLATE = [
  [
    'emisNumber',
    'numberAchieved',
    'numberAchievedProgressed',
    'numberBachelors',
    'numberDiploma',
    'numberEnrolled',
    'numberHigherCertificate',
    'numberNSCFail',
    'numberNSCPass',
    'numberProgressed',
    'numberWrote',
    'numberWroteProgressed',
    'term',
    'year',
    'grade',
    'promotionStatus',
    'dateAccessed',
    'dateCreated',
    'dataSource',
    'dateSchoolSubmitted',
  ],
  [
    200300002,
    23,
    23,
    23,
    23,
    23,
    1234,
    23,
    23,
    23,
    23,
    23,
    'term 1',
    '2015',
    3,
    'Not Promoted',
    '29/03/2020',
    '27/02/2020',
    'DBE Report',
    '21/02/2020',
  ],
];

export const NSC_SUBJECT_TEMPLATE = [
  [
    'year',
    'term',
    'emisNumber',
    'subjectCode',
    'subject',
    'numberEnrolled',
    'numberProgressed',
    'numberWrote',
    'numberAchieved',
    'numberAchievedProgressedLearners',
    'numberAchievedWithDistinction',
    'subjectAverage',
    'numberWroteProgressed',
    'numberAchievedProgressed',
    'numberProgressedLearners',
    'numberWroteProgressedLearners',
    'grade',
    'promotionStatus',
    'dateAccessed',
    'dateCreated',
    'dataSource',
    'dateSchoolSubmitted',
  ],
  [
    '2008',
    'term',
    200300002,
    12351024,
    'Mathematics',
    23,
    23,
    1234,
    23,
    23,
    40,
    23,
    23,
    23,
    23,
    23,
    12,
    'Not Promoted',
    '29/03/2020',
    '27/02/2020',
    'DBE Report',
    '21/02/2020',
  ],
];
export const TEST_PERFORMANCE_TEMPLATE = [
  [
    'year',
    'term',
    'emisNumber',
    'grade',
    'subjectCode',
    'subject',
    'promotionStatus',
    'numberEnrolled',
    'numberAbsent',
    'numberWrote',
    'level1',
    'level2',
    'level3',
    'level4',
    'level5',
    'level6',
    'level7',
    'passRate',
    'averageMark',
    'dateAccessed',
    'dateCreated',
    'dataSource',
    'dateSchoolSubmitted',
  ],
  [
    2018,
    'Term 4',
    200300002,
    12,
    12351024,
    'Accounting',
    'Not Promoted',
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    26,
    21,
    '29/03/2020',
    '27/02/2020',
    'SA-SAMS',
    '21/02/2020',
  ],
];
export const SCHOOL_PROGRESSION_TEMPLATE = [
  [
    'averageMark',
    'class',
    'cluster',
    'control',
    'emisNumber',
    'level1',
    'level2',
    'level3',
    'level4',
    'level5',
    'level6',
    'level7',
    'numberBachelors',
    'numberAbsent',
    'numberEnrolled',
    'numberWrote',
    'passRate',
    'term',
    'treatment',
    'year',
    'circuit',
    'district',
    'grade',
    'institution',
    'promotionStatus',
    'province',
    'region',
    'subject',
  ],
  [
    32.2,
    'My Class',
    'My Cluster',
    true,
    1234,
    23,
    23,
    23,
    23,
    23,
    1234,
    23,
    23,
    23,
    23,
    32.1,
    'term',
    true,
    '2008',
    'my circuit',
    'Fezile Dabi',
    7,
    'A.M.BAM JP SCHOOL',
    'my promotion status',
    'Gauteng',
    'my region',
    'Mathematics',
  ],
];

export const SCHOOL_TEST_TEMPLATE = [
  [
    'averageMark',
    'circuit',
    'emisNumber',
    'level1',
    'level2',
    'level3',
    'level4',
    'level5',
    'level6',
    'level7',
    'numberAbsent',
    'numberEnrolled',
    'numberWrote',
    'passRate',
    'possibleAttendance',
    'prevPromStatus',
    'term',
    'year',
    'district',
    'grade',
    'institution',
    'subject',
  ],
  [
    32.2,
    'My circuit',
    23,
    23,
    1234,
    23,
    23,
    23,
    23,
    23,
    1234,
    23,
    23,
    23.2,
    23,
    'promotion status',
    'term',
    '2008',
    'Fezile Dabi',
    7,
    'Mathematics',
    'A.M.BAM JP SCHOOL',
  ],
];

export const SCHOOL_SUBJECT_TEMPLATE = [
  [
    'averageMark',
    'class',
    'cluster',
    'emisNumber',
    'level1',
    'level2',
    'level3',
    'level4',
    'level5',
    'level6',
    'level7',
    'numberAbsent',
    'numberEnrolled',
    'numberWrote',
    'passRate',
    'term',
    'year',
    'circuit',
    'district',
    'grade',
    'institution',
    'promotionStatus',
    'province',
    'region',
    'subject',
  ],
  [
    32.2,
    'My Class',
    'My Cluster',
    1234,
    23,
    23,
    23,
    23,
    23,
    1234,
    23,
    23,
    23,
    23,
    32.1,
    'term',
    '2008',
    'my circuit',
    'Fezile Dabi',
    7,
    'A.M.BAM JP SCHOOL',
    'my promotion status',
    'Gauteng',
    'my region',
    'Mathematics',
  ],
];

export const MULTIPLE_INSTITUTIONS = [
  [
    'institutionId',
    'institution',
    'yearEcdStartedOperating',
    'ecdServiceType',
    'classification',
    'isEcdServicePrimarySchoolBased',
    'numberOfDaysServiceOperate',
    'hasHolidays',
    'openingTime',
    'closingTime',
    'languageOfLearning',
    'registrationType',
    'newOrRenewal',
    'registrationStatus',
    'pcrLevel',
    'certificateNumber',
    'issueDate',
    'expiryDate',
    'progStatus',
    'progLevel',
    'progCertificateNumber',
    'progCertificateIssueDate',
    'progCertificateExpiryDate',
    'organisationName',
    'networkName',
    'privateOrNpo',
    'registrationNumber',
    'registeredAsNpo',
    'npoNumber',
    'building',
    'sharedBuilding',
    'classrooms',
    'kitchen',
    'space',
    'outdoor',
    'toilet',
    'toilets_children',
    'toilets_gender',
    'capture_toilets_total',
    'count_toilets_children',
    'count_toilets_adults',
    'heating',
    'lighting',
    'cooking',
    'water',
    'waterother',
    'potable',
    'handwashing',
    'mealsProvided',
    'foodProvider',
    'foodProviderOther',
    'monthlyFeeRangeLowest',
    'monthlyFeeRangeHighest',
    'numberOfStaff',
    'count_staff_male',
    'count_staff_female',
    'count_staff_other',
    'count_staff_salary_paid',
    'count_staff_salary_unpaid',
    'count_staff_contract_permanent',
    'count_staff_contract_temporary',
    'count_staff_contract_substitute',
    'count_staff_time_full',
    'count_staff_time_part',
    'count_staff_cat_educator',
    'count_staff_cat_practitioner',
    'count_staff_cat_manager',
    'count_staff_cat_support',
    'professionals_practitioners',
    'count_staff_qual_skills',
    'count_staff_qual_nqf4_5',
    'count_staff_qual_nqf6_9',
    'numberOfChildrenEnrolled',
    'ageRange0To12Months',
    'ageRange1To2Years',
    'ageRange2To3Years',
    'ageRange3To4Years',
    'ageRange4To5Years',
    'ageRange5To6Years',
    'gradeROffered',
    'mainFundingSource',
    'fundingother',
    'receivesDBESubsidy',
    'confirm_subsidy',
    'fundedThroughEquitableShare',
    'numberOfChildrenFunded',
    'fundedThroughConditionalGrant',
    'fundedThroughTopUpSubsidy',
    'numChildrenSubsidisedCG',
    'numChildrenSubsidisedTU',
    'assessedForMaintenanceGrant',
    'receivedMaintenanceGrant',
    'yearOfReceipt',
    'infrastructureGrantBudget',
    'monthlyCGBudgetTotal',
    'monthlyESBudgetTotal',
    'registeredCapacity',
    'ecdEmploymentStimulus',
    'dateECDESRFReceived',
    'emisNumber',
    'country',
    'province',
    'district',
    'districtMunicipality',
    'localMunicipality',
    'wardLabel',
    'physicalAddress',
    'suburb',
    'townshipVillage',
    'townCity',
    'locality',
    'postalAddress',
    'postalCode',
    'gisLatitude',
    'gisLongitude',
    'gisAltitude',
    'gisSource',
    'nearestPointOfInterest',
    'pointOfInterest',
    'officeEmailAddress',
    'officeContactNumber',
    'contactPersonDesignation',
    'contactPersonFullName',
    'contactPersonContactNumber',
    'contactPersonEmail',
    'alternativeContactPersonDesignation',
    'alternativeContactPersonFullName',
    'alternativeContactPersonContactNumber',
    'alternativeContactPersonEmail',
    'registrationOffice',
    'identifiedBy',
    'identifiedDate',
    'sspSupervisor',
    'sspSupervisorEmail',
    'socialServicesProfessional',
    'socialServicesProfessionalEmail',
    'duplicateReference',
    'duplicateAction',
    'reasonForDuplicateAction',
    'trackingCode',
    'verified',
    'validated',
    'dataSource',
    'censusDate',
    'censusId',
    'isArchived',
    'monthlyTopUpSubsidyTotal',
  ],
  [
    ,
    'HANSIE EN GRIETJIE',
    ,
    ,
    'CENTRE BASED',
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    'ZAMON4323',
    true,
    ,
    ,
    ,
    ,
    ,
  ],
];

export const COMMON_ASSOCIATE_PEOPLE_TO_SP_TEMPLATE: TemplateType = [
  ['System ID', 'Name', 'Surname', 'Institution'],
  ['', 'Oswald', 'Ward', 'AB XUMA PRIMARY SCHOOL'],
];

export const LEARNERS_ASSOCIATE_PEOPLE_TO_SP_TEMPLATE: TemplateType = [
  ['System ID', 'Name', 'Surname', 'Institution', 'Grade'],
  ['', 'Oswald', 'Ward', 'AB XUMA PRIMARY SCHOOL', '8'],
];

export const STUDENT_STAKEHOLDER_TEMPLATE = [
  [
    'Type',
    'Name',
    'Surname',
    'National ID',
    'Gender',
    'Date Of Birth',
    'Population Group',
    'Home Language',
    'Contact Number',
    'Email Address',
    'Tracking ID',
    'Disability',
    'Disability Type',
    'Primary Institution',
    'Primary Start Date',
    'Primary End Date',
    'Additional Institutions',
    'Additional  Start Date',
    'Additional  End Date',
    'Caregiver Name',
    'Caregiver Surname',
    'Caregiver National ID',
    'Caregiver Contact Number',
  ],
  [
    'Students',
    'Leilani',
    'Khona',
    ,
    'Male',
    '1990-03-11',
    'Black African',
    'Ndebele',
    '1-684-610-2726',
    'example@yahoo.com',
    '8f1a6a28-30a6-4d37-b2cb-4287f16416f3',
    false,
    ,
    '443907266',
    '2020-01-01',
    '2021-12-31',
    '443611257/442204243',
    '2020-01-01/2020-01-01',
    '2021-12-31/2021-12-31',
    'Concepcion',
    'Swift',
    ,
    '342-192-1743 x75512',
  ],
];

export const MULTIPLE_ECD_REGISTRATIONS = [
  [
    'institutionId',
    'institution',
    'district',
    'localMunicipality',
    'wardLabel',
    'emisNumber',
    'trackingCode',
    'identifiedBy',
    'dateIdentified',
    'dateAssigned',
    'socialServicesProfessional',
    'sspSupervisor',
    'newOrRenewal',
    'registrationType',
    'applicationCollectionType',
    'dateAttended',
    'dateInvited',
    'dateCollected',
    'applicationSubmissionType',
    'dateSubmitted',
    'submissionNumber',
    'documentReviewStatus',
    'dateSubmissionCompleted',
    'assessEcdFrameworkOnline',
    'applicationNotes',
    'numberOfChildrenPresent',
    'numberOfStaffPresent',
    'registrationOutcome',
    'siteAssessmentOutcome',
    'dateOfDSDSiteVisit',
    'dateOfEHPSiteVisit',
    'dateEHPReportReceived',
    'reasonForAssessmentDelay',
    'otherAssessmentDelayReasons',
    'dateFileCompilationSubmitted',
    'programmeAssessmentOutcome',
    'progRegistrationOutcome',
    'certificateNumber',
    'issueDate',
    'expiryDate',
    'pcrLevel',
    'progCertificateNumber',
    'progCertificateIssueDate',
    'progCertificateExpiryDate',
    'progLevel',
    'dateCertificateReceivedFromDistrict',
    'reasonForCertificationDelay',
    'dateCertificateDispensed',
    'dateProgCertificateReceivedFromDistrict',
    'reasonForProgCertificationDelay',
    'dateProgCertificateDispensed',
    'assessmentNotes',
  ],
  [
    '',
    '1000 Hills Community Helpers',
    '',
    '',
    '',
    '',
    '',
    'DSD Office',
    '02/08/2023',
    '02/08/2023',
    'Ayanda Mtanyana',
    'Data Innovators',
    '',
    '',
    '',
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
  ],
];

export const MANAGEMENT_TEMPLATE: TemplateType = [
  [
    'Institution',
    'District',
    'Local Municipality',
    'Ward Label',
    'Emis Number',
    'Tracking Code',
    'Province',
    'Circuit',
    'Registration Office',
    'SSP Supervisor',
    'SSP Supervisor Email',
    'Social Services Professional',
    'Social Services Professional Email',
  ],
  [
    '1 GP Registration',
    'ILEMBE',
    '',
    '',
    '',
    '',
    'KwaZulu-Natal',
    'MAPHUMULO',
    'KwaZulu-Natal',
    'Data Innovators',
    'institutions@impactboard.tech',
    'Thanu Padayachee',
    'thanu@lusa.co.za',
  ],
];

export const KRUTHAM_TEMPLATE: TemplateType = [
  [
    'Record Nr',
    'New Learner / Existing Learner / Re-instated Learner',
    'Full Names',
    'Surname / Last Name',
    'ID Number/ Passport Number',
    'Date of Birth (YYYY/MM/DD)',
    'Equity /Population Group',
    'Household Language',
    'Cell Phone Number and alternate if available',
    'Learner Contact Email Address',
    'Residential Address Line1 <<Street>>',
    'Residential Address Line2 <<Suburb>>',
    'Residential Address Line3 <<City/Town>>',
    'Residential Address Postal Code',
    'Residential Address LOCAL Municipality',
    'Residential Address DISTRICT Municipality',
    'Residential Address METROPOLITAN Municipality',
    'Residential Address Province',
    'Located within one of the Metros?  Y/N',
    'Rural? Y/N',
    'Blind',
    'Partially sighted',
    'Deaf',
    'Hearing Impaired/Hard of Hearing/Deafened',
    'Deaf-Blind',
    'Neurodevelopmental/ Intellectual Disabilities',
    'Psychosocial Disability',
    'Physical Disability',
    'Learning Programme Category',
    'Learning Programme Name',
    'Cohort Name/Number ',
    'OFO Code (Upto 6 digits)',
    'Occupational Title',
    "Occupation on DHET's list of Occupations in High Demand: 2018? Y/N",
    "Occupation on DHET's list of Occupations in High Demand: 2020? Y/N",
    'ECONOMIC SECTOR (related to the Learning Programme)',
    'Name of Public University / Public University of Technology / Public TVET College where learner received theoretical learning',
    'SAQA Qualification ID / Learnership ID',
    'NQF Level',
    'Learning Programme Start Date (YYYY/MM/DD)',
    'Learning Programme End Date (YYYY/MM/DD)',
    'Learning  Site Name',
    'Learning Site Physical Address Line1 <<Street>>',
    'Learning Site Physical Address Line2 <<Suburb>>',
    'Learning Site Physical Address Line3 <<City/Town>>',
    'Learning Site Physical Address Postal Code',
    'Learning Site Physical Address LOCAL Municipality',
    'Learning Site Physical Address DISTRICT Municipality',
    'Learning Site Physical Address METROPOLITAN Municipality',
    'Learning Site Province',
    'Latitude (Decimal)',
    'Longitude (Decimal)',
    'Located within one of the Metros? Y/N',
    'Rural? Y/N',
    'Skills development initiative in response to innovation and digital technology Y/N',
    'First Name',
    'Surname / Last Name',
    'Site Phone Number',
    'Contact Person Cell Phone Number',
    'Contact Person Email Address',
    'Learner status as at 30 June 2023',
    'Reasons for status? (Dropped-out/Withdrawn learners only)',
    'Date of completion of training OR date of dropped-out  (YYYY/MM/DD)',
    'Identity Document',
    'Matric Certificate',
    'Proof of Residence',
    'Learner status as at 30 September 2023',
    'Reasons for status? (Dropped-out/Withdrawn learners only)',
    'Date of completion of training OR date of dropped-out  (YYYY/MM/DD)',
    'Learner status as at 31 December 2023',
    'Reasons for status? (Dropped-out/Withdrawn learners only)',
    'Date of completion of training OR date of dropped-out  (YYYY/MM/DD)',
    'Learner status as at 31 March 2024',
    'Reasons for status? (Dropped-out/Withdrawn learners only)',
    'Date of completion of training OR date of dropped-out  (YYYY/MM/DD)',
    'Name of SMME / Co-operative (If Applicable)',
    'Name of Constituency (If Applicable)',
  ],
  [
    '2',
    'yes',
    'John',
    'Doe',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
  ],
];
